import * as React from "react";
import { makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import { List, ListItem, ListItemAvatar, ListItemText } from "@material-ui/core";
import { MedewerkerAvatar } from "../../atoms/views/MedewerkerAvatar";
import { MedewerkerText } from "../../atoms/views/MedewerkerText";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { useTranslation } from 'react-i18next';


interface MedewerkerInfo {
    fullName: string;
    isActive: boolean;
}

// All the incoming values
interface IProps {
    size?: "small" | "medium" | "large";
}

// Outgoing functions
interface IDispatch {

}

// Actual Component
export type AllProps = IProps & IDispatch & IDefaultViewProps<MedewerkerInfo[]>;
export const MedewerkersList = (props: AllProps) => {
    const classes = useStyles(useTheme());
    const { t: tDatatypes } = useTranslation('datatypes');
    
    const size = props.size || "medium";
    const label = props.label || tDatatypes('medewerkersLabel') || "Medewerkers";
    const dense = size === "small"
    return (<Caption {...props} caption={label} ><List dense={dense}>
        {props.value.map((medewerker, index) => (
            <ListItem key={index}>
                <ListItemAvatar>
                    <MedewerkerAvatar size={size} medewerker={medewerker} />
                </ListItemAvatar>
                <ListItemText>
                    <MedewerkerText medewerker={medewerker} />
                </ListItemText>
            </ListItem>
        ))}
    </List></Caption>)
}

// CSS
const useStyles = makeStyles((theme: Theme) => ({ }));